"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var useButton = function useButton() {
  var pressHandler = function pressHandler(event, onPress, onClick) {
    event.target.dispatchEvent(new Event('click'));
    onPress(event);
    onClick(event);
  };
  return {
    pressHandler: pressHandler
  };
};
var _default = exports.default = useButton;